import Statsig from "statsig-js";

const test = async () => {
  await Statsig.initialize('client-xwopDL8b2en4yPGCHLxYqGlyaJDzmvho1qcpoHoPwk0', { userID: 'test1234' },{ environment: { tier: "staging" }})
  const isMobileResolution = Statsig.checkGate("mobile_registration")
  console.log(isMobileResolution);
}

const statSig = {
  init: () => {
    // test()
  },
};


export default statSig;
